import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Product} from "../../../../model/product";
import ProductUtils from "../../../../utils/product-utils";
import {ProductValueFormComponent} from "../../products-container/product-value-form/product-value-form.component";
import {Property} from "../../../../model/property";
import {FolioNumberComponent} from "../../../folio-number/folio-number.component";
import {LandregisterfolioUtils} from "../../../../utils/LandregisterfolioUtils";

@Component({
  selector: 'app-teilun-information',
  templateUrl: './teilun-information.component.html',
  styleUrls: ['./teilun-information.component.css']
})
export class TeilunInformationComponent implements OnInit {

  teilunProduct: Product;
  selectedProperty: Property;
  @ViewChild(ProductValueFormComponent) productValueFormComponent: ProductValueFormComponent;
  @ViewChild(FolioNumberComponent) folioNumberComponent: FolioNumberComponent;

  protected readonly ProductUtils = ProductUtils;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private readonly dialogRef: MatDialogRef<TeilunInformationComponent>) {}

  /**
   * Initializes the component:
   * - Sets the first product from the dialog data as 'teilunProduct'
   * - Sets the selected property from the dialog data
   */
  ngOnInit(): void {
    this.teilunProduct = this.data?.products?.[0] ?? undefined;
    this.selectedProperty = this.data?.selectedProperty ?? undefined;
  }

  /**
   * Closes the dialog, passing 'false' to indicate cancellation
   */
  public cancelModal(): void{
    this.dialogRef.close(false);
  }

  /**
   * Validates the product value form of the product value form component (if it exists) and closes the modal.
   * The modal will not close, if the form is not valid
   */
  public submitModal(): void {
    // Validate product value form
    if (this.productValueFormComponent && !this.productValueFormComponent.isProductValueFormValid()) {
      return;
    }

    // If folioNumberComponent is displayed, validate it
    if (this.folioNumberComponent) {
      const isFolioNumberFormValid = this.folioNumberComponent.isFolioNumberFormValid();
      if (!isFolioNumberFormValid && !this.data.isConnectOrigin) {
        return;
      }

      const formValues = this.folioNumberComponent.folioNumberForm.get('numbers')?.value ?? [];
      LandregisterfolioUtils.createFoliosIfMissing(this.selectedProperty);
      LandregisterfolioUtils.assignFolioNumbers(this.selectedProperty.landregisterfolios, formValues);

      this.selectedProperty.dataResearch =
          this.folioNumberComponent.folioNumberForm.get('dataResearch')?.value ?? false;
    } else if (!this.data.isConnectOrigin) {
      // folioNumberComponent missing, but required -> block submit
      return;
    }

    // Close modal only if above didn’t return
    this.dialogRef.close(true);
  }
}
